// Copyright (c) 2022 Deere & Company

import {
    createErrorMessage,
    createInfoMessage,
    createSuccessMessage,
    createWarningMessage
} from '../../shared/action-creators/alert-messages';
import {getStore} from '../../store-factory';
import {translate} from '../../shared/services/translation-service';

export const errorAlertBar = errorObject => {

    const dispatch = getStore().dispatch;

    if (typeof errorObject.message === 'string') {

        errorObject.isTranslated ?
            dispatch(createErrorMessage(errorObject.message)) :
            dispatch(createErrorMessage(translate(errorObject.message)));

    } else {

        dispatch(createErrorMessage(translate('ERROR_UNHANDLED')));

    }

};

export const createErrorObject = (message, isTranslated = true) =>
    ({isTranslated, message});

export const warningAlertBar = message => {

    const dispatch = getStore().dispatch;

    dispatch(createWarningMessage(translate(message)));

};

export const infoAlertBar = message => {

    const dispatch = getStore().dispatch;

    dispatch(createInfoMessage(translate(message)));

};

export const successAlertBar = message => {

    const dispatch = getStore().dispatch;

    dispatch(createSuccessMessage(translate(message)));

};




// WEBPACK FOOTER //
// ./src/shared/services/alert-bar.js